import { BigWinAnimationConfig } from "../../types/UCInterfaces";

export const getBigWinTextAnimationConfig = (levelNumber: number): BigWinAnimationConfig => {
    switch (levelNumber) {
        case 5:
            return {
                initialX: 0,
                initialY: 336,
                initialScale: 0.45,
                pivotY: 26,
            };

        case 4:
            return {
                initialX: 0,
                initialY: 324,
                initialScale: 0.44,
                pivotY: 26,
            };

        case 3:
            return {
                initialX: 0,
                initialY: 330,
                initialScale: 0.43,
                pivotY: 26,
            };

        case 2:
            return {
                initialX: 0,
                initialY: 324,
                initialScale: 0.42,
                pivotY: 26,
            };

        default:
            return {
                initialX: 0,
                initialY: 324,
                initialScale: 0.41,
                pivotY: 26,
            };
    }
};
